import {
  CURRENCY_CONFIG,
  DEFAULT_CURRENCY_CODE,
} from "../constants/currencies.constants";

// Workers cannot import this file.
// Keep this config duplicated in dataDownloaderWorker.js and in sync.
export const formattedCurrencyValue = (value, currency) => {
  const currencyMeta =
    CURRENCY_CONFIG[currency] || CURRENCY_CONFIG[DEFAULT_CURRENCY_CODE];

  const currencyCode = currencyMeta.currencyCode;
  const currencyLanguage = currencyMeta.languageCode;
  const currencySymbol = currencyMeta.symbol;
  const isChineseCurrency = currencyCode === CURRENCY_CONFIG.Yuan.currencyCode;

  if (!value) {
    return isChineseCurrency
      ? `${value}${currencySymbol}`
      : `${currencySymbol}${value}`;
  }

  let formattedValue = parseFloat(value).toLocaleString(currencyLanguage, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (isChineseCurrency) {
    // Move symbol from start to end: ¥123.45 -> 123.45¥ or -¥123.45 -> -123.45¥
    const symbolChar = formattedValue.charAt(value > 0 ? 0 : 1);
    formattedValue =
      value > 0
        ? formattedValue.slice(1) + symbolChar
        : formattedValue.charAt(0) + formattedValue.slice(2) + symbolChar;
  }

  return formattedValue;
};
